import { render, staticRenderFns } from "./CadastrarFornecedor.vue?vue&type=template&id=7dc8d7f1&lang=pug"
import script from "./CadastrarFornecedor.vue?vue&type=script&lang=js"
export * from "./CadastrarFornecedor.vue?vue&type=script&lang=js"
import style0 from "./CadastrarFornecedor.vue?vue&type=style&index=0&id=7dc8d7f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports